<template>
  <v-card>
    <v-card-title
      primary-title
    >
      <span class="title">Create Tag Rule</span>
    </v-card-title>
    <v-card-text>
      <Tag />
    </v-card-text>
  </v-card>
</template>

<script>
import Tag from '../_components/Tag';

export default {
  name: 'CreateTag',
  components: {
    Tag,
  },
};
</script>
